export default "__VITE_ASSET__f7064671__"